"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addParamsToUrl = void 0;
var _analyticsData = require("@ori/analytics-data");
var _constants = require("../components/BannerProductListing/constants");
const addParamsToUrl = (param)=>{
    let { url: path, placement, ignoredPlacements = [
        _analyticsData.Placement.ProductListing
    ], params = {} } = param;
    const [baseUrl, queryString = ''] = path.split('?');
    const urlParams = new URLSearchParams(queryString);
    if (placement !== undefined && !ignoredPlacements.includes(placement)) {
        urlParams.set(_constants.ORIGIN_QUERY_KEY, encodeURIComponent(placement));
    }
    Object.entries(params).forEach((param)=>{
        let [key, value] = param;
        urlParams.set(key, encodeURIComponent(value));
    });
    return "".concat(baseUrl, "?").concat(urlParams.toString());
};
exports.addParamsToUrl = addParamsToUrl;
